"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.STATUS_TEMPLATE = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _createCancellable2 = _interopRequireDefault(require("../lib/createCancellable"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var STATUS_TEMPLATE = {
  notStarted: true,
  isLoading: false,
  hasFinished: false,
  hasError: false
};
exports.STATUS_TEMPLATE = STATUS_TEMPLATE;

var usePromise = function usePromise(promiseGetter) {
  var effectVals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$lazy = _ref.lazy,
      lazy = _ref$lazy === void 0 ? false : _ref$lazy;

  if (!Array.isArray(effectVals)) throw new Error('must pass an array of effectVals');

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      response = _useState2[0],
      setResponse = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      err = _useState4[0],
      setErr = _useState4[1];

  var _useState5 = (0, _react.useState)(_objectSpread(_objectSpread({}, STATUS_TEMPLATE), {}, {
    isLoading: !lazy,
    notStarted: lazy
  })),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      status = _useState6[0],
      setStatus = _useState6[1];

  var reqCancel = (0, _react.useRef)(function () {});
  var start = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _createCancellable,
        cancelToken,
        cancel,
        _len,
        imperativeArgs,
        _key,
        newResponse,
        _args = arguments;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setStatus(_objectSpread(_objectSpread({}, STATUS_TEMPLATE), {}, {
              isLoading: true,
              notStarted: false
            }));
            setErr(null);
            setResponse(null);
            _createCancellable = (0, _createCancellable2["default"])(), cancelToken = _createCancellable.token, cancel = _createCancellable.cancel; // eslint-disable-next-line fp/no-mutation

            reqCancel.current = cancel;
            _context.prev = 5;

            for (_len = _args.length, imperativeArgs = new Array(_len), _key = 0; _key < _len; _key++) {
              imperativeArgs[_key] = _args[_key];
            }

            _context.next = 9;
            return promiseGetter({
              cancelToken: cancelToken,
              imperativeArgs: imperativeArgs
            });

          case 9:
            newResponse = _context.sent;
            setStatus(_objectSpread(_objectSpread({}, STATUS_TEMPLATE), {}, {
              hasFinished: true,
              notStarted: false
            }));
            setErr(null);
            setResponse(newResponse);
            _context.next = 20;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](5);
            setStatus(_objectSpread(_objectSpread({}, STATUS_TEMPLATE), {}, {
              hasFinished: true,
              hasError: true,
              notStarted: false
            }));
            setErr(_context.t0);
            setResponse(null);

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 15]]);
  })), [lazy].concat((0, _toConsumableArray2["default"])(effectVals)));

  var cancel = function cancel(reason) {
    return reqCancel.current(reason);
  };

  (0, _react.useEffect)(function () {
    if (!lazy) start();
    return cancel;
  }, [start, lazy]);

  var reset = function reset() {
    setStatus(STATUS_TEMPLATE);
    setErr(null);
    setResponse(null);
  };

  return {
    response: response,
    err: err,
    status: status,
    start: start,
    cancel: cancel,
    reset: reset
  };
};

var _default = usePromise;
exports["default"] = _default;